export default "__VITE_ASSET__DRWjnzlA__"